// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

interface ISyncEmailVerificationStatusInput {
    test: boolean,
}

const syncEmailVerificationStatus = async ({
    test,
}: ISyncEmailVerificationStatusInput): Promise<boolean> => {
    const functions = getFunctions();
    const handleSyncEmailVerificationStatus = httpsCallable<
        ISyncEmailVerificationStatusInput,
        boolean
    >(
        functions,
        'syncEmailVerificationStatus',
    );
    return handleSyncEmailVerificationStatus({
        test,
    }).then((result) => {
        const emailVerified = result.data as boolean;
        return emailVerified;
    }).catch((err) => {
        throw err;
    });
};

export default syncEmailVerificationStatus;
